module.exports = __webpack_public_path__ + "static/img/looking-forward.d99ca2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homepage/looking-forward.jpg
// module id = 1L8p
// module chunks = 0